<template>
  <div>
    <!-- Titulo -->
    <div
  style="position: absolute; top: 0; left: 50%; transform: translate(-50%, -70px); color: black; font-size: min(calc(1vw + 4px), 16px); font-weight: bold; z-index: 2; display: flex; align-items: center;"
>
  <v-icon
    v-if="input.customized.variable_engine"
    class="mt-0 engine-icon"
    :color="failureAlarmValue ? 'red' : engineValue ? 'green' : '#7e827f'"
    dark
    style="z-index: 1; margin-right: 2px;"
  >
    mdi-circle
  </v-icon>
  <span class="bomb-title">
    {{ input.customized.name }}
    <span class="volume-display">
      ({{ input.customized.maximum_value ? `${ (input.customized.maximum_value / 1000) } m³` : "" }})
    </span>
  </span>
</div>


    <!-- Tanque -->
    <canvas
      @click="openTank"
      ref="tankCanvas"
      style="position: absolute; width: 100%; height: 80%; cursor: pointer"
    ></canvas>

    <!-- Canvas Etiqueta -->
    <canvas
      v-show="$vuetify.breakpoint.mdAndUp"
      @click="openTank"
      ref="labelCanvas"
      :style="labelCanvasStyle"
    ></canvas>
  
    <!-- Bombas -->
    <canvas
      @click="showBomb = true"
      v-show="input.customized.bomba"
      ref="motorCanvas"
      class="motor-canvas"
    ></canvas>

    <!-- Mostrar bombas -->
    <v-dialog v-if="!editing" v-model="showBomb" max-width="500">
      <v-card
        class="custom-card bomb-card"
        style="height: inherit"
      >
        <v-card-title
          class="d-flex flex-column align-start pt-2 pb-2"
          :style="{ backgroundColor: bombFailureAlarmValue ? `red` : `#e3eef9` }"
        >
          <div class="table-title">
            Electroválvula abrir Tanque {{ input.customized.name }}
          </div>
        </v-card-title>

        <v-card-text class="mt-2 pt-1">
          <v-row>
            <v-col cols="4">
              <v-btn
                elevation="2"
                outlined
                block
                small
                style="background-color: #e3eef9"
                color="rgb(61, 59, 59)"
                @click="setRunOrderValue(true)"
              >
                ABRIR
              </v-btn>
            </v-col>
            <v-col cols="4">
              <v-btn
                elevation="2"
                outlined
                block
                small
                style="background-color: #e3eef9"
                color="rgb(61, 59, 59)"
                @click="setRunOrderValue(false)"
              >
                CERRAR
              </v-btn>
            </v-col>
            <v-col cols="4">
              <div class="centered-div">
                <v-icon
                  class="mt-0"
                  medium
                  :color="continuousRunningValue ? `green` : `#7e827f`"
                  dark
                >
                  mdi-circle
                </v-icon>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Mostrar tanques -->
    <v-dialog v-if="!editing" v-model="showTank" max-width="500">
    <v-card
      class="custom-card agitator-card"
      style="height: inherit"
    >
      <v-card-title
        class="d-flex flex-column align-start pt-2 pb-2"
        :style="{ backgroundColor: !isLaboratory() && failureAlarmValue ? `red` : `#e3eef9` }"
      >
        <div class="table-title">
          Tanque {{ input.customized.name }}
          {{ input.customized.maximum_value ? `(${ (input.customized.maximum_value / 1000) } m³)` : "" }}
        </div>
      </v-card-title>

      <v-card-text class="mt-3" style="position: relative">
        <!-- === SECCIÓN: BOTONES DE CONTROL === -->
        <v-row v-if="!isLaboratory()">
          <v-col cols="12">
            <div class="control-section mb-4">
              <v-row>
                <v-col cols="8">
                  <MoveableComponent
                    v-if="input.customized.run_order_configuration.customized.write_address"
                    :item="input.customized.run_order_configuration"
                  >
                    <component
                      :is="input.customized.run_order_configuration.settings.component_type"
                      :input="input.customized.run_order_configuration"
                      :tank="input.customized"
                    />
                  </MoveableComponent>

                  <MoveableComponent
                    v-if="input.customized.discontinuous_order_configuration.customized.write_address"
                    :item="input.customized.discontinuous_order_configuration"
                  >
                    <component
                      :is="input.customized.discontinuous_order_configuration.settings.component_type"
                      :input="input.customized.discontinuous_order_configuration"
                      :tank="input.customized"
                    />
                  </MoveableComponent>

                  <MoveableComponent
                    v-if="input.customized.stop_order_configuration.customized.write_address"
                    :item="input.customized.stop_order_configuration"
                  >
                    <component
                      :is="input.customized.stop_order_configuration.settings.component_type"
                      :input="input.customized.stop_order_configuration"
                      :tank="input.customized"
                    />
                  </MoveableComponent>

                  <MoveableComponent
                    v-if="input.customized.continuous_order_configuration.customized.write_address"
                    :item="input.customized.continuous_order_configuration"
                  >
                    <component
                      :is="input.customized.continuous_order_configuration.settings.component_type"
                      :input="input.customized.continuous_order_configuration"
                      :tank="input.customized"
                    />
                  </MoveableComponent>
                </v-col>

                <v-col cols="4" class="d-flex align-center justify-center">
                  <div class="centered-div">
                    <v-icon
                      v-if="input.customized.variable_engine"
                      class="mt-0"
                      medium
                      :color="engineValue ? `green` : `#7e827f`"
                      dark
                    >
                      mdi-circle
                    </v-icon>
                  </div>
                </v-col>
              </v-row>
            </div>

            <!-- Separador visual -->
            <v-divider class="my-3"></v-divider>
          </v-col>
        </v-row>

        <!-- === SECCIÓN: VOLUMEN Y TEMPERATURA === -->
        <v-row class="mt-8 mt-sm-10">
          <v-col
            cols="6"
            @click="showVolumeHistoryDialog = true"
          >
            <div class="text-center body-2 py-2 measurement-section">
              <div class="font-weight-medium">Vol:</div>
              <div>{{ value > 1000 ? Math.round(value) : (value || 0).toFixed(2) }} L</div>
            </div>
          </v-col>

          <v-col
            cols="6"
            @click="showTemperatureHistoryDialog = true"
          >
            <div
              v-if="input.customized.temp_address"
              class="text-center body-2 py-2 measurement-section"
            >
              <div class="font-weight-medium">Tmp:</div>
              <div>
                {{ temperatureValue > 1000 ? Math.round(temperatureValue) : (temperatureValue || 0).toFixed(2) }} ºC
                <v-btn
                  v-if="input.customized.offset && (isAdmin() || isDeveloper() || isRamos())"
                  @click.stop="openOffsetDialog"
                  icon
                  x-small
                  class="ml-1"
                >
                  <v-icon small>mdi-thermometer</v-icon>
                </v-btn>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card-text>

      <!-- Acciones inferiores -->
      <v-card-actions v-if="!isLaboratory()">
        <v-spacer></v-spacer>
        <v-btn
          v-if="input.customized.variator_speed_configuration?.customized.address"
          icon
          @click="showVariatorSpeedDialog = true"
        >
          <v-icon>mdi-car-speed-limiter</v-icon>
        </v-btn>
        <v-btn
          v-if="!isProduction()"
          icon
          @click="showTimeConfigurationDialog = true"
        >
          <v-icon>mdi-timer-cog-outline</v-icon>
        </v-btn>
        <v-btn
          v-if="!isProduction()"
          icon
          @click="showVolumeCalibrationDialog = true"
        >
          <v-icon>mdi-arrow-expand-vertical</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
    </v-dialog>
    <v-dialog
      v-model="showVariatorSpeedDialog"
      max-width="1000px"
    >
      <v-card class="custom-card">
        <v-card-title class="d-flex flex-column align-start">
          <div class="table-title">Configurar velocidad del variador de Tanque {{ input.customized.name }}</div>
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col v-if="input.customized.variator_speed_configuration">
              <v-card-text>
                <MoveableComponent :item="input.customized.variator_speed_configuration">
                  <component
                    :is="input.customized.variator_speed_configuration.settings.component_type"
                    :input="input.customized.variator_speed_configuration"
                    :tank="input.customized"
                  >
                  </component>
                </MoveableComponent>
              </v-card-text>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="pb-4">
          <v-spacer></v-spacer>
          <v-btn @click="showVariatorSpeedDialog = false"> Cerrar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="showTimeConfigurationDialog"
      max-width="1000px"
    >
      <v-card class="custom-card">
        <v-card-title class="d-flex flex-column align-start">
          <div class="table-title">
            Configurar tiempos de funcionamiento discontinuo Tanque {{ input.customized.name }}
          </div>
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col v-if="input.customized.running_time_configuration">
              <v-card-text>
                <MoveableComponent :item="input.customized.running_time_configuration">
                  <component
                    :is="input.customized.running_time_configuration.settings.component_type"
                    :input="input.customized.running_time_configuration"
                    :tank="input.customized"
                  >
                  </component>
                </MoveableComponent>
              </v-card-text>
            </v-col>
            <v-col v-if="input.customized.stopped_time_configuration">
              <v-card-text>
                <MoveableComponent :item="input.customized.stopped_time_configuration">
                  <component
                    :is="input.customized.stopped_time_configuration.settings.component_type"
                    :input="input.customized.stopped_time_configuration"
                    :tank="input.customized"
                  >
                  </component>
                </MoveableComponent>
              </v-card-text>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="pb-4">
          <v-spacer></v-spacer>
          <v-btn @click="showTimeConfigurationDialog = false"> Cerrar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="showVolumeCalibrationDialog"
      max-width="1000px"
    >
      <v-card class="custom-card">
        <v-card-title class="d-flex flex-column align-start">
          <div class="table-title">Calibrar volumen de Tanque {{ input.customized.name }}</div>
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col>
              <div class="label-write">
                <p class="label-write-text">Volumen tara: 0</p>
              </div>
            </v-col>
            <v-col>
              <v-switch
                inset
                dense
                hide-details
                class="pt-4 mt-1"
                label="Tara"
                v-model="volumeTareOrder"
              ></v-switch>
            </v-col>

            <v-col>
              <div class="v-label pt-4 mt-2">Resultado: {{ volumeTareResult ? "CORRECTO" : "PENDIENTE" }}</div>
            </v-col>
          </v-row>
          <v-row>
            <v-col v-if="input.customized.volume_calibration_configuration">
              <v-card-text>
                <MoveableComponent :item="input.customized.volume_calibration_configuration">
                  <component
                    :is="input.customized.volume_calibration_configuration.settings.component_type"
                    :input="input.customized.volume_calibration_configuration"
                  >
                  </component>
                </MoveableComponent>
              </v-card-text>
            </v-col>
            <v-col>
              <v-switch
                inset
                dense
                hide-details
                class="pt-4 mt-1"
                label="Calibración"
                v-model="volumeCalibrationOrder"
              ></v-switch>
            </v-col>

            <v-col>
              <div class="v-label pt-4 mt-2">Resultado: {{ volumeCalibrationResult ? "CORRECTO" : "PENDIENTE" }}</div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="pb-4">
          <v-spacer></v-spacer>
          <v-btn @click="showVolumeCalibrationDialog = false"> Cerrar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo con campo para offset -->
    <v-dialog v-model="dialogOffset" max-width="400px">
      <v-card>
        <v-card-title class="headline">Ajustar Offset</v-card-title>

        <v-card-text>
          <!-- Indicador de temperatura base -->
          <div class="mb-2 grey--text text--darken-1">
            Temperatura base: 
            <strong>
              {{
                temperatureValue > 1000
                  ? Math.round(temperatureValue)
                  : (temperatureValue || 0).toFixed(2)
              }} ºC
            </strong>
          </div>

          <!-- Campo para el offset -->
          <v-text-field
            v-model.number="temperatureOffsetInput"
            label="Offset de temperatura (ºC)"
            type="number"
            step="0.1"
          />
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="grey" @click="dialogOffset = false">Cancelar</v-btn>
          <v-btn text color="primary" @click="putTmpOffset">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";

import emptyTankWithoutShadeImageSrc from "@/plugins/tank_canvas/assets/empty_tank_without_shade.png";
import emptyTankWithShadeImageSrc from "@/plugins/tank_canvas/assets/empty_tank_with_shade.png";
import tankLiquidImageSrc from "@/plugins/tank_canvas/assets/tank_liquid.png";
import MotorApagadoImageSrc from "@/plugins/tank_canvas_quesos/assets/motorApagado.png";
import MotorEncendidoImageSrc from "@/plugins/tank_canvas_quesos/assets/motorEncendido.png";
import MoveableComponent from "@/components/generic/MoveableComponent.vue";
export default {
  name: "koiote-tank-canvas-quesos",

  props: {
    input: Object,
  },
  components: {
    MoveableComponent,
  },
  data() {
    return {
      emptyTankWithShadeImage: null,
      emptyTankWithoutShadeImage: null,
      tankLiquidImage: null,
      motorApagadoImage: null,
      motorEncendidoImage: null,
      showTank: false,
      showBomb: false,
      showVolumeCalibrationDialog: false,
      showTimeConfigurationDialog: false,
      showVariatorSpeedDialog: false,
      dialogOffset: false,
      temperatureOffsetInput: 0,
      labelCanvasStyle: {
        position: "absolute",
        height: "40%",
        top: "10%",
        left: "20%",
        zIndex: 2,
        background: "rgba(255, 255, 255, 0.6)",
        border: "1px solid black",
        width: "0px",
        cursor: "pointer"
      }
    };
  },

  computed: {
    ...mapState(["editing"]),

    vartable() {
      return this.actualPage().global_item_list.find((gi) => gi.settings.component_type.includes("connection"))
        .customized.vartable;
    },
    allImagesLoaded() {
      return this.emptyTankWithShadeImage != null && this.emptyTankWithoutShadeImage != null && this.tankLiquidImage && this.motorApagadoImage != null && this.motorEncendidoImage != null;
    },
    write_topic() {
      return this.actualPage().global_item_list.find((gi) => gi.settings.component_type == "koiote-snap7-connection")
        .customized.topic_write;
    },
    //Tanques
    value() {
      try {
        return (
        this.vartable.find((v) => v.formatted_address == this.input.customized.volume_address)?.value || 0
      );
      } catch (error) {
        '?'
      }
    },
    temperatureOffset() {
      try {
        return (
       
        this.vartable.find((v) => v.formatted_address == this.input.customized.offset)?.value || 0
      );
      } catch (error) {
        '?'
      }
    },
    temperatureValue() {
      try {
        return (
       
        this.vartable.find((v) => v.formatted_address == this.input.customized.temp_address)?.value || 0
      );
      } catch (error) {
        '?'
      }
    },
    volumeCalibrationResult() {
      return this.vartable?.find((v) => v.formatted_address == this.input.customized.variable_volume_calibration_result)
        ?.value;
    },
    volumeTareResult() {
      return this.vartable?.find((v) => v.formatted_address == this.input.customized.variable_volume_tare_result)
        ?.value;
    },
    volumeTareOrder: {
      get() {
        return (
          this.vartable?.find((v) => v.formatted_address == this.input.customized.variable_volume_tare_order)?.value ==
          true
        );
      },
      set(value) {
        const variableToChange =
          this.vartable?.find((v) => v.formatted_address == this.input.customized.variable_volume_tare_order) || {};
        variableToChange.value = value;
        this.doPublish({
          topic: this.write_topic,
          message: {
            address: variableToChange?.address,
            value: this.adaptFormat({ type: "BIT", value }),
          },
        }, `Tarado del tanque ${this.input.customized.name}`);
      },
    },
    volumeCalibrationOrder: {
      get() {
        return (
          this.vartable?.find((v) => v.formatted_address == this.input.customized.variable_volume_calibration_order)
            ?.value == true
        );
      },
      set(value) {
        const variableToChange =
          this.vartable?.find((v) => v.formatted_address == this.input.customized.variable_volume_calibration_order) ||
          {};
        variableToChange.value = value;
        this.doPublish({
          topic: this.write_topic,
          message: {
            address: variableToChange?.address,
            value: this.adaptFormat({ type: "BIT", value }),
          },
        }, `Calibración del tanque ${this.input.customized.name}`);
      },
    },
    engineValue() {
      return this.vartable?.find((v) => v.formatted_address == this.input.customized.variable_engine)?.value;
    },
    failureAlarmValue() {
      return this.vartable?.find((v) => v.formatted_address == this.input.customized.variable_failure_alarm)?.value;
    },

    //Bombas
    bombFailureAlarmValue() {
      return this.vartable?.find((v) => v.formatted_address == this.input.customized.variable_bomb_failure_alarm)?.value;
    },
    continuousRunningValue() {
      return this.vartable?.find((v) => v.formatted_address == this.input.customized.variable_continuous_running)
        ?.value;
    },

    calibracionVol(){
      return this.vartable?.find((v) => v.formatted_address == this.input.customized.volume_calibration_configuration.customized.address)?.value;
    },

    confirmTara() {
      return this.vartable?.find((v) => v.formatted_address == this.input.customized.tara_confirm)?.value;
    },
    confirmCal() {
      return this.vartable?.find((v) => v.formatted_address == this.input.customized.calib_confirm)?.value;
    },
    taraPuntos() {
      return this.vartable?.find((v) => v.formatted_address == this.input.customized.puntos_tara)?.value;
    },
    calPuntos() {
      return this.vartable?.find((v) => v.formatted_address == this.input.customized.puntos_calib)?.value;
    },
  },

  methods: {
    ...mapGetters(["actualPage", "isProduction", "isLaboratory", "isAdmin", "isDeveloper", "isRamos", "isManteni", "isCalidad"]),
    ...mapActions("nodered", ["doPublish"]),
    ...mapActions(["postData"]),

    openTank(){
      if (this.isManteni() || this.isCalidad()) return;
      this.showTank = true
    },

    // Tanques -------------------------------------------------------------
    async applyMask() {
      const canvas = this.$refs.tankCanvas;
      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      if (this.emptyTankWithoutShadeImage && this.tankLiquidImage && this.emptyTankWithShadeImage && canvas) {
        const newHeight = (this.value * canvas.height) / (this.input?.customized?.maximum_value || 100);

        const dy = canvas.height - newHeight;
        await ctx.drawImage(this.tankLiquidImage, 0, dy, canvas.width, newHeight);

        ctx.globalCompositeOperation = "destination-in";
        await ctx.drawImage(this.emptyTankWithoutShadeImage, 0, 0, canvas.width, canvas.height);

        ctx.globalCompositeOperation = "multiply";
        await ctx.drawImage(this.emptyTankWithShadeImage, 0, 0, canvas.width, canvas.height);
      }
      this.drawLabelCanvas();
    },
    drawLabelCanvas() {
      const canvas = this.$refs.labelCanvas;
      const ctx = canvas.getContext("2d");

      ctx.clearRect(0, 0, canvas.width, canvas.height); // Limpia el canvas

      // Dibuja el texto en el canvas de la etiqueta
      const volumeText = this.input.customized.volume_address ? `${ this.value > 1000 ? Math.round(this.value) : (this.value || 0).toFixed(2) } L`: "";
      // const volMaxText = this.input.customized.maximum_value ? `${ this.input.customized.maximum_value } L`: "";
      const tempText = this.input.customized.temp_address ? `${ this.temperatureValue > 1000 ? Math.round(this.temperatureValue) : (this.temperatureValue || 0).toFixed(2) } ºC` : "";
      ctx.fillStyle = "black";
      ctx.font = "40px Arial";
      ctx.fillText(volumeText, 85, 60);
      // ctx.fillText(volMaxText, 85, 100);
      ctx.fillText(tempText, 85, 120); // Dibuja el texto en la posición deseada
    },

    loadEmptyTankWithShadeImage() {
      const img = new Image();
      img.src = emptyTankWithShadeImageSrc;
      img.onload = () => (this.emptyTankWithShadeImage = img);
    },

    loadEmptyTankWithoutShadeImage() {
      const img = new Image();
      img.src = emptyTankWithoutShadeImageSrc;
      img.onload = () => (this.emptyTankWithoutShadeImage = img);
    },

    loadTankLiquidImage() {
      const img = new Image();
      img.src = tankLiquidImageSrc;
      img.onload = () => (this.tankLiquidImage = img);
    },

    // Bombas ---------------------------------------------------------------------------
    async makeMotorBomba() {
      const canvas = this.$refs.motorCanvas;
      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      const img = this.continuousRunningValue ? this.motorEncendidoImage : this.motorApagadoImage;
      if(canvas && img) {
        await ctx.drawImage(img, 0, 0, canvas.width, canvas.height)
      }
    },

    loadMotorApagadoImage() {
      const img = new Image();
      img.src = MotorApagadoImageSrc;
      img.onload = () => (this.motorApagadoImage = img);
    },

    loadMotorEncendidoImage() {
      const img = new Image();
      img.src = MotorEncendidoImageSrc;
      img.onload = () => (this.motorEncendidoImage = img);
    },

    setRunOrderValue(value) {
      const variableToChange = this.vartable.find(
        (v) => v.formatted_address == this.input.customized.variable_run_order
      );
      variableToChange.value = value;
      this.doPublish({
        topic: this.write_topic,
        message: {
          address: variableToChange.address,
          value: this.adaptFormat({ type: "BIT", value }),
        },
        description: `Electrovalvula del tanque ${this.input.customized.name} en ${value ? "Marcha" : "Paro"}`
      });
    },
    putTmpOffset(){
      const variableToChange = this.vartable.find(
        (v) => v.formatted_address == this.input.customized.offset
      );
      this.doPublish({
        topic: this.write_topic,
        message: {
          address: variableToChange.address,
          value: this.adaptFormat({ type: "REAL", value: this.temperatureOffsetInput }),
        },
      });
      this.dialogOffset = false;
    },

    adaptFormat(item) {
      return (() => {
        switch (item.type) {
          case "BIT":
            return item.value;
          case "ENTERO":
          case "REAL":
            return Number(item.value);
          default:
            return "";
        }
      })();
    },

    setCanvasWidth() {
      const tankCanvas = this.$refs.tankCanvas;
      if (tankCanvas) {
        console.log("Si que esta tankcanvas")
        const tankCanvasWidth = tankCanvas.offsetWidth * 0.63;
        if (window.innerWidth < 850) {
          this.labelCanvasStyle.width = `${tankCanvasWidth * 2}px`;
          this.labelCanvasStyle.left = `${-10}%`;
        } else this.labelCanvasStyle.width = `${tankCanvasWidth}px`;
      }else {
        console.log("no esta tankcanvas")
      }
    },
    openOffsetDialog(){
      this.temperatureOffsetInput = this.temperatureOffset.toFixed(2);
      this.dialogOffset = true;
    }
  },

  mounted() {
    this.loadMotorEncendidoImage();
    this.loadMotorApagadoImage()
    this.loadEmptyTankWithShadeImage();
    this.loadEmptyTankWithoutShadeImage();
    this.loadTankLiquidImage();
    this.setCanvasWidth();
    window.addEventListener("resize", this.setCanvasWidth);
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.setCanvasWidth);
  },

  watch: {
    value() {
      this.applyMask();
    },
    temperatureValue() {
      this.drawLabelCanvas();
    },

    continuousRunningValue() {
      this.makeMotorBomba();
    },

    allImagesLoaded(value) {
      if (value) {
        this.applyMask();
        this.makeMotorBomba();
      }
    },
    // async confirmTara(value){
    //   if(value){
    //     // guardar solo puntos tara , volumen calibration es 0
    //     try{
    //       console.log("guardamos puntos tara", this.taraPuntos);
    //       let id_tank = null;
    //       if(this.input.customized.name.includes("SE")) id_tank = 17;
    //       else if (this.input.customized.name.includes("SD")) id_tank = 18;
    //       else id_tank = parseInt(this.input.customized.name);

    //       const payload = {
    //         tank_id: id_tank,
    //         puntos_tara: this.taraPuntos
    //       }
    //       const response = await this.postData({ path: "tanks/tara", body:  payload});

    //     } catch(e){
    //       console.error("Error al guardar en base de datos los puntos tara", e);
    //     }
    //   }
    // },
    // async confirmCal(value){
    //   if(value){
    //     // guardar puntos calibracion y volumen calibracion
    //     try{
    //       console.log("guardamos volumen y puntos cal", this.calibracionVol, this.calPuntos);
    //       let id_tank = null;
    //       if(this.input.customized.name.includes("SE")) id_tank = 17;
    //       else if (this.input.customized.name.includes("SD")) id_tank = 18;
    //       else id_tank = parseInt(this.input.customized.name);

    //       const payload = {
    //         tank_id: id_tank,
    //         puntos_cal: this.calPuntos,
    //         vol_cal: this.calibracionVol,
    //       }
    //       const response = await this.postData({ path: "tanks/calibracion", body:  payload});
    //       console.log(response);

    //     } catch(e){
    //       console.error("Error al guardar en base de datos la calibracion", e);
    //     }

    //   }
    // },

    input: {
      handler() {
        this.applyMask();
        this.makeMotorBomba();
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.motor-canvas {
  position: absolute;
  top: 80%;
  left: 50%;
  transform: translateX(-50%);
  cursor: pointer;
  width: 70px;
  height: 50px;
}

/* En pantallas grandes, reducir */
@media (min-width: 1200px) {
  .motor-canvas {
    width: 50px;
    height: 36px; /* 50 * (50/70) ≈ 36 */
  }
}

/* En móviles, hacerlo más pequeño */
@media (max-width: 600px) {
  .motor-canvas {
    width: 40px;
    height: 29px;
  }
}

.volume-display {
  font-size: 0.85em;
  display: inline; /* Visible en pantallas grandes */
}

.bomb-title {
  font-size: 0.9em; /* o el tamaño que prefieras */
}

/* Ocultar en pantallas pequeñas */
@media (max-width: 768px) {
  .volume-display {
    display: none;
  }
}
.engine-icon {
  font-size: 12px !important; /* ajusta el valor que necesites */
}
.control-section {
  background-color: #f9f9f9;
  border-radius: 8px;
  padding: 12px;
}

.measurement-section {
  background-color: #f5f5f5;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.measurement-section:hover {
  background-color: #eee;
}
</style>
